import type { VoidFunctionComponent } from 'react';

import { useGetCurrentPlan } from '../../../../hooks/subscriptions/useGetCurrentPlan';
import Flex from '../../../generic/Flex';
import Loader from '../../../generic/Loader';
import { usePlansContext } from '../plans/PlansContext';

import PlanDetails from './PlanDetails';
import PlanInfo from './PlanInfo';

const CurrentPlan: VoidFunctionComponent = () => {
  const {
    data,
    isLoading: isLoadingCurrentPlan,
  } = useGetCurrentPlan();

  const { freePrice, isLoading: isLoadingPlans } = usePlansContext();

  if (isLoadingCurrentPlan || isLoadingPlans) {
    return (<Loader />);
  }

  if (!data || !freePrice?.product) {
    return null;
  }

  return (
    <Flex direction="column" gap={32} align="unset">
      <PlanInfo data={data} freePrice={freePrice} />
      <PlanDetails data={data} freePrice={freePrice} />
    </Flex>
  );
};

export default CurrentPlan;
